import Component from '@Component';

export default class MobileNavToggle extends Component {
  static loaderPriority = 'in-view';
  static selector = '[data-comp-mobile-nav-toggle]';

  #state = {
    visible: false,
  }

  constructor(element) {
    super(element);
    this.navTarget = document.querySelector('[data-comp-mobile-nav-target ]');
    // this.navComponent = this.navTarget?.component;
    this.events();
  }

  events() {
    this.$container.addEventListener('click', () => {
      this.navTarget.classList.toggle('header-nav__links--visible');
      this.$container.classList.toggle('header-nav__menu-btn--active');
      this.toggleState();
      this.toggleBodyStyle();
    });

    window.addEventListener('resize', () => {
      this.hideMenu();
    });
  }

  hideMenu() {
    this.navTarget.classList.remove('header-nav__links--visible');
    this.$container.classList.remove('header-nav__menu-btn--active');
    this.#state.visible = false;
    Object.assign(document.body.style, {
      overflow: null,
      position: null,
      height: null,
      width: null,
    });
  }

  toggleState() {
    if (this.#state.visible === false) {
      this.#state.visible = true;
    } else {
      this.#state.visible = false;
    }
  }

  toggleBodyStyle() {
    if (this.#state.visible === true) {
      this.setBodyStyle();
    } else {
      this.removeBodyStyle();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  setBodyStyle() {
    Object.assign(document.body.style, {
      overflow: 'hidden',
      position: 'fixed',
      height: '100%',
      width: '100%',
    });
  }

  // eslint-disable-next-line class-methods-use-this
  removeBodyStyle() {
    Object.assign(document.body.style, {
      overflow: null,
      position: null,
      height: null,
      width: null,
    });
  }
}
